/**
 * ProductTemplates Queries
 */

import gql from 'graphql-tag'

export const getProductsTemplatesQuery = gql`
  query getProductTemplates(
    $sort: String
    $limit: Int
    $offset: Int
    $searchText: String
  ) {
    getProductTemplates(
      limit: $limit
      sort: $sort
      offset: $offset
      searchText: $searchText
    ) {
      fullCount
      products {
        id
        name
        shortDescription: short_description
        templateZip: template_zip
        images: pictures2 {
          thumbnail
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductTemplates/data.ts